<script setup>
import FetchPlanCardsComponent from '@/components/FetchPlanCardsComponent.vue';

</script>

<template>
  <div class="bg-primary text-basecolor py-8 md:py-24 sm:px-2 lg:px-4">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="max-w-4xl px-4">
        <h2 class="text-3xl font-bold tracking-tight">
          {{ $t('landingPage.prices.title') }}
        </h2>
        <h3 class="mt-12 text-xl font-bold">
          {{ $t('landingPage.prices.subtitle') }}
        </h3>
      </div>

      <FetchPlanCardsComponent class="px-4" />

      <div class="mt-12">
        <p class="mt-12 text-md" v-html="$t('landingPage.prices.unsubscribe.text')"></p>
      </div>
    </div>
  </div>
</template>
